<script setup lang="ts">
import { computed } from 'vue'
import NotificationTabEnum from '../../../../../../Constants/NotificationTabEnum.ts'

interface Props {
  showFooter?: boolean
  activeTab?: string
}

const props = withDefaults(defineProps<Props>(), {
  showFooter: false,
  activeTab: NotificationTabEnum.TEAM,
})

const notificationUrl = computed(() => {
  return `/notifications/index.php#/notifications${props.activeTab === NotificationTabEnum.TEAM ? '?team=true' : ''}`
})
</script>

<template>
  <div class="d-flex align-items-center px-3 mt-3" v-if="showFooter">
    <span class="footer-divider"></span>
    <small class="text-muted px-2 footer-limit-text">
      {{ $t('notification.footer.limit') }}
    </small>
    <span class="footer-divider"></span>
  </div>

  <div class="text-center px-3 py-2 bg-white">
    <a :href="notificationUrl" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-block rounded-pill">
      <i class="ti-time mr-1"></i> {{ $t('notification.footer.history') }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
.footer-divider {
  flex: 1;
  height: 0.063rem;
  background-color: rgba(25, 55, 105, 0.15);
}

.footer-limit-text {
  font-size: 0.688rem;
}
</style>
